module.exports = __webpack_public_path__ + "static/media/03.8c142b06.mp3";